import React from 'react'
import { compact } from 'lodash'

import css from './style.scss'

const Label = ({ children, className = '', htmlFor, style }) => {
  const classNames = [css.label, className]
  return (
    <label id={htmlFor ? `${htmlFor}-label` : undefined} className={compact(classNames).join(' ')} htmlFor={htmlFor} style={style}>
      {children}
    </label>
  )
}

Label.propTypes = {
  htmlFor: React.PropTypes.string,
  children: React.PropTypes.node
}

export default Label
